














import ECharts from 'vue-echarts'
import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {
	GetAbnormityStatistics
} from "@/api/report"

@Component({
	components: {ECharts}
})
export default class Age extends AbpBase {
	tab:String = 'default'
	tabs:Array<any> = []
	loading = false
	year = new Date()
	echartsData: any = {
		tooltip: {
			trigger: 'axis'
		},
		// 数据标题
		legend: {
			data: [' ']
		},
		grid: {
			left: '3%',
			right: '4%',
			bottom: '3%',
			containLabel: true
		},
		toolbox: {
			feature: {
				saveAsImage: {}
			}
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			data: [] // X轴坐标点
		},
		yAxis: {
			type: 'value'
		},
		series: [
			{
				name:'数量',
				type:'line',
				stack: '总量',
				data:[]
			},
		]
	}
	data: any = []
	tabClick(name:String){
		this.tab = name
	}
	tabRemove(name:any){
		let pos = 0
		this.tabs.forEach((item:any, index:any) => {
			if (item.type === name) {
				pos = index
			}
		})
		if (pos) {
			this.tabs.splice(pos, 1)
		}
	}
	columns = [
		{
			title: this.year.getFullYear(),
			key: 'type'
		},
		{
			title: "1月",
			key: '1'
		},
		{
			title: "2月",
			key: '2'
		},
		{
			title: "3月",
			key: '3'
		},
		{
			title: "4月",
			key: '4'
		},
		{
			title: "5月",
			key: '5'
		},
		{
			title: "6月",
			key: '6'
		},
		{
			title: "7月",
			key: '7'
		},
		{
			title: "8月",
			key: '8'
		},
		{
			title: "9月",
			key: '9'
		},
		{
			title: "10月",
			key: '10'
		},
		{
			title: "11月",
			key: '11'
		},
		{
			title: "12月",
			key: '12'
		}
	]
	created() {
		this.getData()
	}

	private async getData() {
		this.loading = true
		let query: any = {
			year: this.year.getFullYear()
		}
		this.columns[0].title = this.year.getFullYear()
		// let res = await GetAbnormityStatistics(query)
		// this.data = res.objects
		this.data = [
			{
				"type":"乙肝E抗原",
				"1":0,
				"2":0,
				"3":0,
				"4":0,
				"5":0,
				"6":0,
				"7":0,
				"8":0,
				"9":0,
				"10":0,
				"11":0,
				"12":0,
			},
			{
				"type":"乙肝表面抗原",
				"1":0,
				"2":0,
				"3":0,
				"4":0,
				"5":0,
				"6":0,
				"7":0,
				"8":0,
				"9":0,
				"10":0,
				"11":0,
				"12":0,
			},
			{
				"type":"丙肝抗体",
				"1":0,
				"2":0,
				"3":0,
				"4":0,
				"5":0,
				"6":0,
				"7":0,
				"8":0,
				"9":0,
				"10":0,
				"11":0,
				"12":0,
			},
			{
				"type":"HIV抗体",
				"1":0,
				"2":0,
				"3":0,
				"4":0,
				"5":0,
				"6":0,
				"7":0,
				"8":0,
				"9":0,
				"10":0,
				"11":0,
				"12":0,
			},

		]  //模拟数据
		let xAxis:any = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
		let series = []
		this.data.forEach((item: any) => {
			this.echartsData.series[0].data.push(item.count)
		})
		this.echartsData.xAxis.data = xAxis
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/yinYang/index.vue